<div class="agent-list-options">
  <div class="agent-list-title-container">
    <p class="agent-list-subtitle">{{ 'agentListTab.subTitle' | translate }}</p>
    <p>{{ 'agentListTab.refreshInfo' | translate }}</p>
  </div>

  <mat-form-field class="filter-field" floatLabel="never">
    <svg-icon icon="magnifier" matPrefix></svg-icon>
    <input matInput (keyup)="filterList($event.target.value)" placeholder="{{ 'agentListTab.searchPlaceholder' | translate }}">
  </mat-form-field>
</div>

<app-loading *ngIf="isListLoading"></app-loading>

<ng-container *ngIf="!isListLoading">
  <div class="agent-list-container" *ngIf="hasAgents()">
    <div class="agent-list-header">
      <div class="header-cell checkbox-header">
        <mat-checkbox [disableRipple]="true" [checked]="allChecked" (change)="checkAllOrNone()" *ngIf="isOtherClientInTheList() && isLogoutActionAvailable()"></mat-checkbox>
      </div>
      <div class="header-cell best-name">
        <div class="column-header-title"
             [ngClass]="{'selected': isColumnHeaderSelected('bestName')}"
             (click)="sortByColumnName('bestName')"
        >
          <span>{{ 'agentListTab.headers.name' | translate }}</span>
          <svg-icon class="header-icon sort-direction"
                    [ngClass]="{'rotated': activeSort.direction === sortDirection.DESC}"
                    icon="sorting">
          </svg-icon>
        </div>
      </div>
      <div *ngFor="let header of serviceHeaders" [ngClass]="['header-cell', 'header-cell-' + header.workItemType.toLowerCase()]">
        <div class="header-left">
          <div class="column-header-title"
               [ngClass]="{'selected': isColumnHeaderSelected(header.workItemType)}"
               (click)="sortByColumnName(header.workItemType)"
          >
            <svg-icon class="header-icon" icon="{{ getIconByWorkItemType(header.workItemType) }}"></svg-icon>
            <span>{{ header.title | translate }}</span>
            <svg-icon class="header-icon sort-direction"
                      [ngClass]="{'rotated': activeSort.direction === sortDirection.DESC}"
                      icon="sorting">
            </svg-icon>
          </div>
          <div class="current-capacity" *ngIf="capacitySums[header.workItemType] !== capacityConstants.N_A">
            {{ serviceHeaderTranslateTexts.CAPACITY | translate }}: {{ capacitySums[header.workItemType] || (serviceHeaderTranslateTexts.UNLIMITED | translate) }}
          </div>
          <div>
            <span class="number">{{ loadSums[header.workItemType] }}</span> {{ serviceHeaderTranslateTexts.ASSIGNED | translate }}
          </div>
          <div>
            <span class="number">{{ getQueueSize(header.workItemType) }}</span> {{ serviceHeaderTranslateTexts.IN_QUEUE | translate }}
          </div>
        </div>
        <div *ngIf="isOmniType(header.workItemType)" class="omni-header">
          <div *ngFor="let includedService of includedServices" class="included-channel">
            <div>
              <svg-icon class="header-icon" icon="{{ getIconByWorkItemType(includedService) }}"></svg-icon>
              <ng2-tooltip direction="top" text="{{ getTooltip(includedService) | translate }}"></ng2-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="agent-list-body">
      <cdk-virtual-scroll-viewport class="scroll-viewport" itemSize="60">
        <div class="agent-list-row" *cdkVirtualFor="let agent of displayedAgentList" @items>
          <div class="list-cell checkbox">
            <mat-checkbox *ngIf="!isOwnClient(agent) && isLogoutActionAvailable()" [checked]="agent.checked" [disableRipple]="true" (click)="$event.stopPropagation()" (change)="changeChecked(agent)"></mat-checkbox>
          </div>
          <div class="list-cell best-name">
            <span>{{ agent.bestName }}</span>
            <span class="self-indicator" *ngIf="isOwnClient(agent)">{{ 'agentListTab.you' | translate }}</span>
          </div>
          <div *ngFor="let service of serviceHeaders" [ngClass]="['list-cell', 'list-cell-' + service.workItemType.toLowerCase()]">
            <div class="divided-cell">
              <ng-container *ngIf="agent.services[service.workItemType]?.statusType">
                <div class="status">
                  <svg-icon *ngIf="!agent.services[service.workItemType]?.customStatusName" icon="dot" [ngClass]="getClassByStatus(agent.services[service.workItemType]?.statusType)"></svg-icon>
                  <div *ngIf="agent.services[service.workItemType]?.customStatusName"
                       class="custom-status"
                       [ngClass]="'custom-' + getClassByStatus(agent.services[service.workItemType]?.statusType)"
                       title="{{ agent.services[service.workItemType]?.customStatusName }}"><span class="custom-status-name">{{ agent.services[service.workItemType]?.customStatusName }}</span></div>
                  <div class="time-in-status">{{ agent.services[service.workItemType]?.created | appElapsed }}</div>
                </div>
                <div class="separator"></div>
                <div class="load-and-capacity" [ngClass]="{'clickable': isClickable(agent, service.workItemType)}" (click)="navigateToAssignedToAgentTab(agent, service.workItemType)">
                  <div>
                    <span class="number">{{ agent.services[service.workItemType]?.load }} </span>
                    <span class="number" *ngIf="showCapacity(agent, service.workItemType) && !isUnlimitedCapacity(agent, service.workItemType)">/ {{ agent.services[service.workItemType]?.capacity }}</span> {{ 'agentListTab.active' | translate }}
                  </div>
                  <div class="capacity-container" *ngIf="showCapacity(agent, service.workItemType)">
                    <span class="capacity" *ngIf="!isUnlimitedCapacity(agent, service.workItemType)">
                      {{ getLoadPercentage(agent, service.workItemType) | percent }}
                    </span>
                    <span class="capacity" *ngIf="isUnlimitedCapacity(agent, service.workItemType)">
                      {{ 'agentListTab.fromUnlimited' | translate }}
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!agent.services[service.workItemType]?.statusType && agent.services[service.workItemType]?.loading">
                <div class="status">
                  <app-skeleton-loader [subItemCount]="1"></app-skeleton-loader>
                </div>
                <div class="separator"></div>
                <div class="load-and-capacity">
                  <app-skeleton-loader [subItemCount]="1"></app-skeleton-loader>
                </div>
              </ng-container>

              <ng-container *ngIf="isOmniType(service.workItemType)">
                <div class="separator"></div>
                <div class="included-channels">
                  <div *ngFor="let includedService of includedServices" class="included-channel">
                    <div class="channel">
                      <div class="load-and-capacity" [ngClass]="{'clickable': isClickable(agent, includedService)}" (click)="navigateToAssignedToAgentTab(agent, includedService)">
                        <span class="number">{{ agent.services[includedService]?.load }} </span>
                      </div>
                    </div>
                    <div class="separator"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <div *ngIf="!hasAgents()" class="empty-state">
    <svg-icon icon="no-agents"></svg-icon>
    <div class="no-agents-title">{{ 'agentListTab.emptyState.noAgentsTitle'| translate}}</div>
    <div class="no-agents-subtitle">{{ 'agentListTab.emptyState.noAgentsSubtitle'| translate}}</div>
  </div>
</ng-container>

<div class="agent-list-panel-footer-buttons" *ngIf="isFooterAvailable()">
  <ng-container>
    <button class="btn btn-light button-logout-agent"
            [disabled]="!anyChecked"
            (click)="showLogOutConfirmation()">
      <span>{{ "agentListTab.buttons.forceLogOut" | translate }}</span>
    </button>
  </ng-container>
</div>
